import {Component, Input, OnInit} from '@angular/core';
import {AbstractControl, NgModel, UntypedFormControl} from '@angular/forms';
import {fadeInAnimation} from '../../animations/fade-in.animation';
import {FormatDateEnum} from '../../enums/utils';

@Component({
  selector: 'app-message-field',
  templateUrl: './message-field.component.html',
  styleUrls: ['./message-field.component.scss'],
  animations: [fadeInAnimation]
})
export class MessageFieldComponent implements OnInit {
  @Input() field: NgModel | UntypedFormControl | AbstractControl;
  @Input() parentField: NgModel;
  @Input() type: 'success' | 'danger' | 'warning' = 'danger';
  @Input() message: string;
  @Input() description: string;
  @Input() position: 'left' | 'center' | 'right' = 'left';
  @Input() positionAbsolute = false;

  formatDate = FormatDateEnum;
  constructor() { }

  ngOnInit(): void {
  }

}
